import { render, staticRenderFns } from "./BalanceSection.vue?vue&type=template&id=649f82a4&"
import script from "./BalanceSection.vue?vue&type=script&lang=js&"
export * from "./BalanceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports